export default {
  index: () => {
    return "/admin";
  },
  projectsList: () => {
    return "/admin/projects"
  },
  project: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.slug;
      }
    }
    return `/admin/projects/${identifier}`;
  },
  usersList: () => {
    return "/admin/users"
  },
  user: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.id;
      }
    }
    return `/admin/users/${identifier}`;
  },
  pagesList: () => {
    return "/admin/pages"
  },
  page: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.slug;
      }
    }
    return `/admin/pages/${identifier}`;
  },
  downloadablesList: () => {
    return "/admin/downloadables"
  },
  downloadable: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.slug;
      }
    }
    return `/admin/downloadables/${identifier}`;
  },
  companiesList: () => {
    return "/admin/companies"
  },
  company: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.id;
      }
    }
    return `/admin/companies/${identifier}`;
  },
  developersList: () => {
    return "/admin/developers"
  },
  developer: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.id;
      }
    }
    return `/admin/developers/${identifier}`;
  },
  countriesList: () => {
    return "/admin/countries"
  },
  country: (item) => {
    let identifier = ":identifier";
    if(item) {
      if(typeof item === 'string') {
        identifier = item;
      }
      else {
        identifier = item.id;
      }
    }
    return `/admin/countries/${identifier}`;
  },
  mailerReadme: () => {
    return "/admin/mailer_readme";
  },
  newsletterEmails: () => {
    return "/admin/newsletter_emails";
  },
  statistics: () => {
    return "/admin/statistics";
  }
}
